// eslint-disable-next-line import/prefer-default-export
export const initialState = {
  receiptPageNumber: 1,
  receiptLimitPage: 10,
  filterData: {},
  ticketFilterData: {},
  retailerCountry: undefined,
  retailerName: undefined,
  retailerPageNumber: 1,
  retailerLimitPage: 10,
  isLoading: false,
  receipts: []
}
